export const getSortList = staticTexts => [
  { name: staticTexts.featured },
  { name: staticTexts.bestSellers, query: `bestSeller_l+asc` },
  { name: staticTexts.priceDesc, query: `price+desc` },
  { name: staticTexts.priceAsc, query: `price+asc` },
  { name: staticTexts.atoz, query: "ProductBrandName_s+asc" },
  { name: staticTexts.ztoa, query: "ProductBrandName_s+desc" },
]

export const resourceFacetLabels = ["ProductIsExclusive_s"]

export const getFlData = persona => [
  "id",
  "slug_s",
  "sourceId_s",
  "preferenceSku_s",
  "metaTitle_s",
  "productName_s",
  "masterSKU_s",
  "Product_Category",
  "ProductLocalCategory_s",
  "ProductBrandName_s",
  "productImages.url_ss",
  "displayPriceStartingAt_s",
  "SKUColorSwatchFilename_ss",
  "ProductDescriptionProductShort_s",
  `priceList.${persona}.price_d`,
  `priceList.${persona}.finalPrice_d`,
  `priceList.${persona}.discountedPrice_d`,
  `priceList.${persona}.saleOffer_s`,
  `priceStartingAt.${persona}_d`,
  `discountedPriceStartingAt.${persona}_d`,
  "variantList.sku_ss",
  "Color.SKU.Details_ss",
  `Color.${persona}.Details_ss`,
  "ProductIsExclusive_s",
  "RegionReleaseforShipment_dt",
  "productImages.labelWithUrl_ss",
  "RegionBrandName_s",
  "ProductIsRetail",
  "category1_s",
  "ProductBrandNameDisplay_s",
  "ctId_s",
  "ProductResource.InteractiveSVG.resourceName_ss",
  "ProductProductNo_s",
  "ProductResource.InteractiveSVG.resourceTitle_ss",
  "ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss",
  "ProductResource.PartsPDFFileName.resourceFullWebURL_ss",
  "BundleList_ss",
  `priceList.ANY.price_d`,
  "InstallationAvailable_s",
  "bundleNameSlugDetails_ss",
  resourceFacetLabels.join(","),
]

export const getFilterQuery = (type, query, queries = [], persona) => {
  const fq = type === "parts" ? [] : [query]
  queries?.forEach(q => {
    const tag = `{!tag="${q.facet}"}`
    if (!q?.facet?.match(/^\*{2}/)) {
      q?.facet === "Price_Range"
        ? fq.push(
            encodeURIComponent(
              `{!tag="priceList.${persona}.finalPrice_d"}priceList.${persona}.finalPrice_d:(${q?.value?.join(
                " OR "
              )})`
            )
          )
        : fq.push(
            encodeURIComponent(
              `${tag + q?.facet}:("${q?.value?.join('" OR "')}")`
            )
          )
      return
    }
    q?.facet === "Price_Range"
      ? fq.push(
          `priceList.${persona}.finalPrice_d:(${encodeURIComponent(q.value)})`
        )
      : fq.push(
          `${q.facet.replace(/^\*{2}/, "")}:("${encodeURIComponent(
            q.value.join('","')
          )}")`
        )
  })
  return fq
}

export * from "../../../../src/components/Search/v1/ProductsTab/helper"
